import { render } from "./CarRequestView.vue?vue&type=template&id=6a88eee8&scoped=true&lang=pug"
import script from "./CarRequestView.vue?vue&type=script&lang=js"
export * from "./CarRequestView.vue?vue&type=script&lang=js"

import "./CarRequestView.vue?vue&type=style&index=0&id=6a88eee8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a88eee8"]])

export default __exports__